import { useAppStore } from '@/stores/app'

export type ShareOutcome = 'shared' | 'copied' | 'cancelled' | 'failed'

export function useShare() {
  const app = useAppStore()

  async function copyText(text: string): Promise<boolean> {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      return false
    }
  }

  function buildShareUrl(path: string, params: Record<string, string>): string {
    const url = new URL(path, app.siteUrl)
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        url.searchParams.set(key, value)
      }
    })
    return url.toString()
  }

  async function shareResult(payload: {
    title: string
    text: string
    url: string
  }): Promise<ShareOutcome> {
    if (navigator.share) {
      try {
        await navigator.share(payload)
        return 'shared'
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') {
          return 'cancelled'
        }
        return (await copyText(payload.url)) ? 'copied' : 'failed'
      }
    }
    return (await copyText(payload.url)) ? 'copied' : 'failed'
  }

  return { copyText, buildShareUrl, shareResult }
}
